import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SearchDropdownComponent } from '../search-dropdown/search-dropdown.component';
import { PaginationTableComponent } from '../pagination-table/pagination-table.component';

@NgModule({
  declarations: [
    SearchDropdownComponent,
    PaginationTableComponent
  ],
  imports: [
    CommonModule, FormsModule
  ],
  exports: [
    SearchDropdownComponent,
    PaginationTableComponent
  ]
})
export class SharedModule { }
